import routePath from '@src/lib/routePath'

const base = '/retailer/embedded-search/:retailerAccountSlug'

const embeddedSearchPaths = {
  root: routePath(base),
  index: routePath(base),
}

export default embeddedSearchPaths
